/* eslint-disable */
import React, {Component} from 'react';
import scriptLoader from 'react-async-script-loader';
const Script = require('react-load-script');

class GooglePlacesLocationSearch extends Component {
  state = {
    query: '',
    places: [],
    showList: false,
    isLoading: false,
    error: null,
  };

  static defaultProps = {
    stylesInput: {},
    stylesContainer: {},
    stylesList: {},
    stylesItem: {},
    stylesLoading: {},
    stylesItemText: {},
    stylesSearchContainer: {},
    queryFields: 'formatted_address,geometry,name',
    placeholder: 'Search places...',
    textInputProps: {},
    language: 'en',
    resultRender: (place) => place.description,
    requiredCharactersBeforeSearch: 2,
    requiredTimeBeforeSearch: 1000,
    value: '',
    hasSearchIcon: false,
    onFocus: () => {},
    onBlur: () => {},
  };

  constructor(props) {
    super(props);
    this.props = props;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({query: nextProps.value});
    const {isScriptLoaded, isScriptLoadSucceed} = nextProps;
    if (isScriptLoaded && !this.props.isScriptLoaded && isScriptLoadSucceed) {
      this.handleScriptLoad();
    }
  }

  handleScriptLoad = () => {
    // Declare Options For Autocomplete
    const options = {
      componentRestrictions: {country: 'za'},
    }; // To disable any eslint 'google not defined' errors

    try {
      // Initialize Google Autocomplete
      /* global google*/
      this.autocomplete = new google.maps.places.Autocomplete(
        this.inputComponent,
        options,
      );

      this.autocomplete.setFields([
        'address_components',
        'formatted_address',
        'geometry',
      ]);
      this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
      this.setState({error: null});
    } catch (err) {
      console.error('Failed to initialize Google Places:', err);
      this.setState({
        error:
          'Address service is unavailable. Please try again or enter address manually.',
      });
    }
  };

  handlePlaceSelect = () => {
    // Extract City From Address Object
    const addressObject = this.autocomplete.getPlace();
    const address = addressObject.address_components;

    // Check if address is valid
    if (address) {
      // Set State

      const address = addressObject ? addressObject.formatted_address : '';
      const latlong = addressObject
        ? addressObject.geometry
          ? addressObject.geometry.location
            ? `${addressObject.geometry.location.lat()},${addressObject.geometry.location.lng()}`
            : ''
          : ''
        : '';
      const addressArray = addressObject
        ? addressObject.address_components.length > 0
          ? addressObject.address_components
          : []
        : [];
      const countryObj = addressArray.find((el) =>
        el.types.find((it) => it == 'country'),
      );
      const provinceObj = addressArray.find((el) =>
        el.types.find((it) => it == 'administrative_area_level_1'),
      );
      this.setState(
        {
          query: addressObject.formatted_address,
        },
        () => {
          this.props.onSelect &&
            this.props.onSelect({
              address,
              latlong,
              country: countryObj ? countryObj.long_name : '',
              province: provinceObj ? provinceObj.long_name : '',
            });
        },
      );
    }
  };
  timeout = null;
  autocomplete;
  handleText(e) {
    const input = e.target;
    this.setState({
      nextError: null,
      query: input.value,
      [`${input.name}Error`]: null,
    });
    const value = e.target.value;
    if (!value && this.props.onCleared) this.props.onCleared();
  }
  setFocusToSearch() {
    if (this.inputComponent) {
      this.inputComponent.focus();
    }
  }

  render() {
    const {query} = this.state;
    const {hasSearchIcon} = this.props;
    const {error} = this.state;
    return (
      <div
        className="google-places-search-container"
        style={{position: 'relative'}}
      >
        {error && (
          <div
            style={{
              color: '#d32f2f',
              fontSize: '12px',
              marginBottom: '8px',
              padding: '8px',
              backgroundColor: '#ffebee',
              borderRadius: '4px',
            }}
          >
            {error}
          </div>
        )}
        <div
          className="google-places-search-inner-container"
          style={{...this.props.stylesContainer}}
        >
          <div style={this.props.stylesSearchContainer}>
            <div className="search-field row" style={{height: '48px'}}>
              <input
                className="search-text"
                type="text"
                ref={(r) => (this.inputComponent = r)}
                id="autocomplete"
                value={query}
                placeholder={this.props.placeholder}
                style={{...styles.input, ...this.props.stylesInput}}
                onChange={(e) => this.handleText(e)}
                onFocus={() => this.props.onFocus()}
                onBlur={() => this.props.onBlur()}
              />
              {hasSearchIcon && (
                <span
                  className="icon fal-search pointer"
                  onClick={() => this.setFocusToSearch()}
                ></span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  input: {
    borderRadius: 6,
    border: 'solid 1px #b1b1b1',
    height: 43,
    backgroundColor: '#fff',
    paddingRight: 15,
    paddingLeft: 15,
    outline: 'none',
    flex: 1,
  },
  scrollView: {
    backgroundColor: '#fff',
    zIndex: 10001,
  },
  placeIcon: {
    position: 'absolute',
    top: 10,
    right: 15,
    color: 'rgba(0,0,0,0.3)',
  },
  placeText: {
    color: 'rgba(0,0,0,0.8)',
    paddingRight: 60,
  },
  loading: {
    margin: 10,
  },
};

// Dynamically create the script loader URL using the googleApiKey prop
const createGooglePlacesComponent = (props) => {
  const apiKey =
    props.googleApiKey || 'AIzaSyAqjBK8fP6gSGZS9oocUYv-bDM-b88cOoo';
  const WrappedComponent = scriptLoader([
    `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`,
  ])(GooglePlacesLocationSearch);
  return <WrappedComponent {...props} />;
};

export default scriptLoader([
  `https://maps.googleapis.com/maps/api/js?key=AIzaSyAqjBK8fP6gSGZS9oocUYv-bDM-b88cOoo&libraries=places`,
])(GooglePlacesLocationSearch);
